<script>
  import { surveyStatus, progress } from '../stores'
  import { QUESTIONS_DEF } from '../constants/questions_def'

  $: if ($surveyStatus.currentQuestionId === 'end_of_survey') {
    $progress = QUESTIONS_DEF.length
  }
</script>

<div
  class={$surveyStatus.currentQuestionId === 'start_survey' ||
  $surveyStatus.currentQuestionId === 'end_of_survey'
    ? 'progress-bar--hidden'
    : 'progress-bar'}
>
  <div class="track" style="width: {($progress / QUESTIONS_DEF.length) * 100}%; " />
</div>

<style>
  .progress-bar--hidden {
    display: none;
  }

  .progress-bar {
    width: calc(100vw - 75px);
    height: 75px;
    background: #222222;
  }

  .track {
    background: rgba(255, 255, 255, 0.2);
    height: 75px;
  }
</style>
